import { CustomError } from "@/services/API";
import { SupportedLanguages } from "@/lib/contexts/internationalization";
import { CustomErrorResponse, API_METHODS } from "../shared";
import { ImportBookingsResultDTO } from "./dtos";
import { BOOKINGS_IMPORT_URL } from "./api-url.constants";

export const importBookings = async (
  file: File,
  language: SupportedLanguages
): Promise<ImportBookingsResultDTO> => {
  const formData = new FormData();
  formData.append("file", file);

  const requestUrl = `${BOOKINGS_IMPORT_URL}?language=${encodeURIComponent(language)}`;

  const response = await fetch(requestUrl, {
    method: API_METHODS.POST,
    credentials: "include",
    body: formData,
  });

  const responseText = await response.text();
  let data: CustomErrorResponse | { data?: ImportBookingsResultDTO } | null = null;

  if (responseText) {
    try {
      data = JSON.parse(responseText) as CustomErrorResponse | { data?: ImportBookingsResultDTO };
    } catch {
      data = null;
    }
  }

  if (!response.ok) {
    if (data && "statusCode" in data) {
      throw new CustomError(data);
    }

    throw new CustomError({
      statusCode: response.status,
      message: responseText || `Request failed with status ${response.status}`,
      timestamp: Date.now(),
    });
  }

  if (data && "statusCode" in data) {
    throw new CustomError(data);
  }

  if (!data) {
    throw new CustomError({
      statusCode: response.status,
      message: "Invalid server response",
      timestamp: Date.now(),
    });
  }

  return data.data ?? (data as ImportBookingsResultDTO);
};
